export const INITIAL_VALUE_SELECT = {
  label: "Selecione",
  value: "",
};

export const SELECT_CATEGORY_INITIAL_VALUE = {
  label: "Categoria",
  value: "",
};

export const CARD_HEADERS_COLORS_TYPES = {
  green: "green",
  default: "default",
  greenDarken: "greenDarken",
  blueDarken: "blueDarken",
};

export const USER_TYPE = {
  ROOT: "root",
  ADMIN: "admin",
  DEV: "dev",
  FINANCIAL: "financial",
  MANAGER: "manager",
  ATTENDANT: "attendant",
  SALE: "sale",
};

export const PRIVILEGES = {
  ADMIN: USER_TYPE.ADMIN,
  DEV: USER_TYPE.DEV,
  FINANCIAL: USER_TYPE.FINANCIAL,
  MANAGER: USER_TYPE.MANAGER,
  ATTENDANT: USER_TYPE.ATTENDANT,
  ROOT: USER_TYPE.ROOT,
  SALE: USER_TYPE.SALE,
};

export const SELECT_XML_SPED = {
  XML: "XML",
  SPED: "SPED",
};

export const TYPE_DATE = {
  MONTHLY: "mensal",
  DAILY: "diario",
};

export const MOVEMENT_TYPE = {
  ENTRADA: "ENTRADA",
  SAIDA: "SAIDA",
};

export const TYPE_MOVEMENT = [
  { label: "Todos", value: "" },
  { label: "Entrada", value: "ENTRADA" },
  { label: "Saída", value: "SAIDA" },
  { label: "Entrada e Saída", value: ["ENTRADA", "SAIDA"] },
  { label: "Transfêrencia Entrada", value: "TRANSF_E" },
  { label: "Transfêrencia Saída", value: "TRANSF_S" },
  { label: "Transfêrencias", value: ["TRANSF_E", "TRANSF_S", "TRANSF"] },
];

// Regimes Tributários (tabela: mxf_regimes_tributarios)
export const REGIME_TRIBUTARIO_IDS = {
  STD: 1, // Padrão
  GOV: 2, // Orgão Governamental
  RURAL: 3, // Produtor Rural
  CONTRI: 4, // Contribuinte
};

export const REGIME_TRIBUTARIO_LABELS = {
  STD: "Padrão",
  GOV: "Orgão Governamental",
  RURAL: "Produtor Rural",
  CONTRI: "Contribuinte",
};
